import { render, staticRenderFns } from "./zxAcvitityFoot.vue?vue&type=template&id=7986bcd1&scoped=true&"
import script from "./zxAcvitityFoot.vue?vue&type=script&lang=js&"
export * from "./zxAcvitityFoot.vue?vue&type=script&lang=js&"
import style0 from "./zxAcvitityFoot.vue?vue&type=style&index=0&id=7986bcd1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7986bcd1",
  null
  
)

export default component.exports